module.exports = __webpack_public_path__ + "af.no2.9646acd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/af.no2.jpg
// module id = pFiQ
// module chunks = 0